import React, { useState, useEffect } from 'react';
import { getDatabase, ref, onValue, remove } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { app } from '../firebase';

import { Divider, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button,TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import './UserTable.css';
import './InfoTale.css'

const UserTable = () => {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const usersPerPage = 10;
    const [openDialog, setOpenDialog] = useState(false);
    const [userIdToDelete, setUserIdToDelete] = useState(null);
    const [userId, setuserId] = useState(null);
    const [hideData, sethideData] = useState(false);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});





    const validate = () => {
        const newErrors = {};
        
        // Validate email
        if (!email) {
          newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
          newErrors.email = 'Email is invalid';
        } else if (email !== 'osiyatest@gmail.com') {
          newErrors.email = ' wrong Email ';
        }
    
        // Validate password
        if (!password) {
          newErrors.password = 'Password is required';
        } else if (password.length < 4) {
          newErrors.password = 'Password must be at least 6 characters';
        } else if (password !== '1234') {
          newErrors.password = 'Wrong Password ';
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            // Form is valid, proceed with the login
            console.log('Form submitted', { email, password });
            sethideData(true)        }
    };










    const navigate = useNavigate();

    // Function to calculate total estimated cost and total price
    const calculateTotals = (doorData) => {
        return doorData.reduce((totals, doorItem) => {
            totals.estimatedCost += parseFloat(doorItem.additionalFields?.estimatedCost) || 0;
            totals.price += parseFloat(doorItem.additionalFields?.price) || 0;
            return totals;
        }, { estimatedCost: 0, price: 0 });
    };

    useEffect(() => {
        const db = getDatabase(app);
        const usersRef = ref(db, 'users');

        const unsubscribe = onValue(usersRef, (snapshot) => {
            console.log('=====');

            const data = snapshot.val();
            const usersList = data ? Object.entries(data).map(([id, user]) => ({ id, ...user })) : [];
            setUsers(usersList);
            if (usersList.length > 0) {
                setSelectedUser(usersList[0]);
            }
        });
        return () => unsubscribe();
    }, []);

    const filteredUsers = users.filter(user =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleUserSelect = (user) => {
        setSelectedUser(user);
    };
    const Z = (id) => {
        setuserId(id)

        setDialog(true);
        // navigate(`/components/doorConfig/${user.id}`)
    }
    const handleDeleteUser = (userId) => {
        const db = getDatabase(app);
        const userRef = ref(db, `users/${userId}`);
        remove(userRef)
            .then(() => {
                console.log('User deleted successfully');
                setOpenDialog(false);
            })
            .catch((error) => {
                console.error('Error deleting user:', error);
            });
    };

    const openDeleteDialog = (userId) => {
        setUserIdToDelete(userId);
        setOpenDialog(true);
    };

    const closeDeleteDialog = () => {
        setOpenDialog(false);
        setUserIdToDelete(null);
    };

    const [editedialog, setDialog] = useState(false)

    const OpenEditDialog = () => {
        setDialog(false);
        navigate(`/components/doorConfig/${userId}`)
    };

    const confirmDelete = () => {
        if (userIdToDelete) {
            handleDeleteUser(userIdToDelete);
        }
    };

    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const displayedUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
    const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

    const handleLoadMore = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const handleLoadPrevious = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
        }
    };

    // Calculate totals for selected user
    const { estimatedCost: totalEstimatedCost, price: totalPrice } = selectedUser && selectedUser.doorData
        ? calculateTotals(selectedUser.doorData)
        : { estimatedCost: 0, price: 0 };

    const closeEditDialog = () => {
        setDialog(false);
        // Remove the navigation call from here
    };



    return (
<div style={{backgroundColor:"#5f1c1d"}}>
        <div className="container" >
        {hideData === false ? (
            <div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh", // Full height for vertical centering
              padding: "20px",
            //   backgroundColor: "#5f1c1d",  
            }}
          >
            {!hideData && (
              <form
                onSubmit={handleSubmit}
                style={{
                  width: "100%", // Full width but with max-width for responsiveness
                  maxWidth: "400px", // Ensuring a good size for the form
                  backgroundColor: "#fff", // White background for the form
                  borderRadius: "8px", // Rounded corners
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Soft shadow for depth
                  padding: "30px", // Ample padding for form content
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px", // Spacing between inputs
                  alignItems: "center", // Centering form elements
                }}
              >
                {/* Add the Image above the Email Input */}
                <div
                  style={{
                    marginBottom: "20px", // Space between image and form
                    width: "100px", // Set the width of the image
                    height: "100px", // Set the height of the image
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* Replace this src with the actual image URL */}
                  <img
                    src="../logo192.png" // Example image URL (replace with your actual image)
                    alt="Logo"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain", // Ensures the image fits properly
                    }}
                  />
                </div>
      
                {/* Email Input Field */}
                {/* <div> */}
                  <TextField
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={!!errors.email}
                    helperText={errors.email}
                    margin="normal"
                    style={{
                        marginTop: "16px", // Margin for better spacing
                        width: "100%", // Button takes full width
                        padding: "12px", // Adding padding for button size
                        fontSize: "16px", // Slightly larger text for readability
                      }}
                   />
                {/* </div> */}
      
                {/* Password Input Field */}
                {/* <div> */}
                  <TextField
                    label="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!errors.password}
                    helperText={errors.password}
                    margin="normal"
                    style={{
                        marginTop: "16px", // Margin for better spacing
                        width: "100%", // Button takes full width
                        padding: "12px", // Adding padding for button size
                        fontSize: "16px", // Slightly larger text for readability
                      }}
                  />
                {/* </div> */}
      
                {/* Login Button */}
                <Button
                  variant="contained"
                   
                  type="submit"
                  style={{
                    marginTop: "16px", // Margin for better spacing
                    width: "100%", // Button takes full width
                    padding: "12px", // Adding padding for button size
                    fontSize: "16px", // Slightly larger text for readability
                    backgroundColor:"#5f1c1d",
                    border:'1px solid #5f1c1d'

                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#fff";
                    e.target.style.color = "#5f1c1d";
                    e.target.style.border = "1px solid #5f1c1d";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#5f1c1d";
                    e.target.style.color = "#fff";
                  }}
                >
                  Login
                </Button>
              </form>
            )}
          </div>
          </div>
        ) 
        
        : 

          <div className="user-table-container">


          <div className="header-container">
              <div className="search-container">
                  <input
                      type="text"
                      placeholder="Search by name..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="search-input"
                  />
                  <SearchIcon className="search-icon" />
              </div>
              <div className="logo-container">
                  <img src='../logo192.png' alt="Logo" className="logo" />
              </div>
          </div>

          <div className="user-list responsive-table table-design">
              <table className="user-table">
                  <thead>
                      <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Actions</th>
                      </tr>
                  </thead>
                  <tbody>
                      {displayedUsers.length === 0 ? (
                          <tr>
                              <td colSpan="3" style={{ textAlign: 'center' }}>
                                  No records found
                              </td>
                          </tr>
                      ) : (
                          displayedUsers.map((user, index) => (
                              <tr key={user.id} onClick={() => handleUserSelect(user)} className="user-row">
                                  <td>{indexOfFirstUser + index + 1}</td>
                                  <td>{user.name}</td>
                                  <td>
                                      <EditIcon
                                          onClick={() => Z(user.id)}
                                          className="action-icon"
                                          style={{ color: 'blue' }}
                                      />
                                      <DeleteIcon
                                          onClick={(e) => { e.stopPropagation(); openDeleteDialog(user.id); }}
                                          className="action-icon"
                                          style={{ color: 'red' }}
                                      />
                                  </td>
                              </tr>
                          ))
                      )}
                  </tbody>
              </table>
          </div>

          <div className="pagination-controls">
              <button onClick={handleLoadPrevious} disabled={currentPage === 1} className="pagination-button button-blank">
                  Prev
              </button>
              <div style={{ marginRight: '15px', marginLeft: "15px", marginTop: '5px' }}>
                  <h2>{currentPage}</h2>
              </div>
              <button onClick={handleLoadMore} disabled={currentPage === totalPages} className="pagination-button button-blank">
                  Next
              </button>
          </div>

          {selectedUser && (
              <div className="user-details">
                  <h3 style={{ fontWeight: 'bold' }}>Details for {selectedUser.name}</h3>
                  <Divider />
                  <div className='responsive-table table-design'>
                  <table className="user-details-table">
                      <thead>
                          <tr>
                              <th>Field</th>
                              <th>Details</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr><td>First Name</td><td>{selectedUser.formData?.firstName}</td></tr>
                          <tr><td>Last Name</td><td>{selectedUser.formData?.lastName}</td></tr>
                          <tr><td>Address</td><td>{selectedUser.formData?.address}</td></tr>
                          <tr><td>City</td><td>{selectedUser.formData?.city}</td></tr>
                          <tr><td>State</td><td>{selectedUser.formData?.state}</td></tr>
                          <tr><td>ZIP Code</td><td>{selectedUser.formData?.zipCode}</td></tr>
                          <tr><td>Year Built</td><td>{selectedUser.formData?.yearBuilt}</td></tr>
                          <tr><td>Phone</td><td>{selectedUser.formData?.phone}</td></tr>
                          <tr><td>Cell</td><td>{selectedUser.formData?.cell}</td></tr>
                          <tr><td>Work</td><td>{selectedUser.formData?.work}</td></tr>
                      </tbody>
                  </table>
                  </div>
                
                  <h3>Door Data</h3>
                  <div className='responsive-table table-design'>
                  <table className="door-details-table">
                      <thead>
                          <tr>
                              <th>Category</th>
                              <th>Detail Type</th>
                              <th>Width (Inches)</th>
                              <th>Height (Inches)</th>
                              <th>Sqft/Lft</th>
                              <th>Unit Cost</th>
                              <th>Estimated Cost</th>
                              <th>Price</th>
                          </tr>
                      </thead>
                      <tbody>
                          {selectedUser.doorData?.map((doorItem, doorIndex) => (
                              <tr key={doorIndex}>
                                  <td>{doorItem.label}</td>
                                  <td>{doorItem.selectedOption}</td>
                                  <td>{doorItem.additionalFields?.field1}</td>
                                  <td>{doorItem.additionalFields?.field2}</td>
                                  <td>{doorItem.additionalFields?.field3}</td>
                                  <td>{doorItem.additionalFields?.field4}</td>
                                  <td>{doorItem.additionalFields?.estimatedCost}</td>
                                  <td>{doorItem.additionalFields?.price}</td>
                              </tr>
                          ))}
                          <tr>
                              <td colSpan={6} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
                              <td>{totalEstimatedCost.toFixed(2)}</td>
                              <td>{totalPrice.toFixed(2)}</td>
                          </tr>
                      </tbody>
                  </table>
                  </div>
              </div>
          )}

          {/* Confirmation Dialog */}
          <Dialog
              open={openDialog}
              onClose={closeDeleteDialog}
              PaperProps={{
                  style: {
                      backgroundColor: '#f8d7da',
                      padding: '20px',
                      borderRadius: '10px',
                  }
              }}
          >
              <DialogTitle>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontWeight: 'bold', color: '#dc3545' }}>⚠️ Delete data</span>
                      <span
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={closeDeleteDialog}
                      >
                          &#10006;
                      </span>
                  </div>
              </DialogTitle>
              <DialogContent>
                  <DialogContentText style={{ color: '#495057', fontWeight: 'bold' }}>
                      Doing so will permanently delete the data at this location, including all nested data.
                  </DialogContentText>
                  <div style={{ marginTop: '10px', fontSize: '14px', color: '#6c757d' }}>
                      Data location: <code>/users/-O9mcV...npq61UBu</code>
                  </div>
                  <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '10px' }}>
                      To delete data without seeing this message, hold shift and click when deleting a node.
                  </div>
              </DialogContent>
              <DialogActions>
                  <Button
                      onClick={closeDeleteDialog}
                      style={{
                          color: '#6c757d',
                          border: '1px solid #6c757d',
                          borderRadius: '4px',
                          textTransform: 'none',
                      }}
                  >
                      Cancel
                  </Button>
                  <Button
                      onClick={confirmDelete}
                      style={{
                          backgroundColor: '#dc3545',
                          color: '#fff',
                          borderRadius: '4px',
                          textTransform: 'none',
                          marginLeft: '10px',
                      }}
                  >
                      Delete
                  </Button>
              </DialogActions>
          </Dialog>

          <Dialog
              open={editedialog}
              onClose={OpenEditDialog}
              PaperProps={{
                  style: {
                      backgroundColor: '#ffffff',
                      padding: '20px',
                      borderRadius: '10px',
                      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                  },
              }}
          >
              <DialogTitle>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontWeight: 'bold', color: '#007bff' }}>✏️ Edit Data</span>
                      <span
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={closeEditDialog}
                      >
                          &#10006;
                      </span>
                  </div>
              </DialogTitle>
              <DialogContent>
                  <DialogContentText style={{ color: '#495057', fontWeight: 'bold' }}>
                      Modify the information below and click save to apply changes.
                  </DialogContentText>


                  <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '10px' }}>
                      Please ensure all information is accurate before saving.
                  </div>
              </DialogContent>
              <DialogActions>
                  <Button
                      onClick={closeEditDialog}
                      style={{
                          color: '#6c757d',
                          border: '1px solid #6c757d',
                          borderRadius: '4px',
                          textTransform: 'none',
                      }}
                  >
                      Cancel
                  </Button>
                  <Button
                      onClick={OpenEditDialog}
                      style={{
                          backgroundColor: '#007bff',
                          color: '#fff',
                          borderRadius: '4px',
                          textTransform: 'none',
                          marginLeft: '10px',
                      }}
                  >
                      Continue
                  </Button>
              </DialogActions>
          </Dialog>

      </div>
    
    }
      

        </div>
        </div>

    );
};

export default UserTable;

